export default __webpack_public_path__ + "static/media/bomb-manhattan-2.2fcb38b2.svg";